import { render, staticRenderFns } from "./ValidSelect.vue?vue&type=template&id=60d17916"
import script from "./ValidSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./ValidSelect.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports